import React from "react";
import Main from "./Main";
import { Link, withRouter } from "react-router-dom";
import {
  Col,
  Icon,
  Modal,
  Preloader,
  ProgressBar,
  Row,
  SideNav,
  SideNavItem,
} from "react-materialize";
import { API_CATEGORY, API_PROVINCE, BASE_URL, CheckAuth } from "./Util";
import $ from "jquery";
import store from "store";
import Notifications from "react-notify-toast";
import { trans } from "./Lang";
import "../styles/app.css";
import UndpLogo from "./../assets/undp.png";
import KemenkesLogo from "./../assets/kemenkes-horizontal.png";

class App extends React.Component {
  constructor(props) {
    super(props);
    store.remove("home_data");

    this.state = {
      loading: false,
      loadingCategory: true,
      categories: [],
      os: null,
      search_url: "/course/catalog",
      ticket_counter: 0,
      language: "id",
    };

    window.onpopstate = function (e) {
      if ($(".modal-overlay").length > 0) {
        $(".modal-overlay").click();
        props.history.go(1);
      }
    };

    this.socmedClick = this.socmedClick.bind(this);

    $(".btn-help").css({
      position: "fixed",
      bottom: "0rem",
      right: "0rem",
    });
  }

  componentDidMount() {
    if (!this.state.categories.length) {
      this.handleLoadData();
    }
  }

  handleLoadData = (e) => {
    var categories = null;

    if (!categories) {
      $.getJSON(API_CATEGORY).then((data) => {
        this.setState({ categories: data.payload, loadingCategory: false });
      });
    } else {
      this.setState({ categories: categories, loadingCategory: false });
    }

    var provinces = store.get("provinces");

    if (!provinces) {
      $.getJSON(API_PROVINCE).then((data) => {
        store.set("provinces", data.payload);
      });
    }
  };

  toggleTopNotification = (saveState, e) => {
    $("#root").toggleClass("mt-65");
    if (saveState) {
      store.set("top-notification", true);
    }
  };

  handleSearchCourse = (target, e) => {
    e.preventDefault();
    let param = { query: $(target).val() };

    $(target).blur();

    this.props.history.push("/search?" + $.param(param));
  };

  socmedClick = (e) => {
    console.log(e.target);
  };

  render() {
    let counter = this.state.ticket_counter;
    trans.setLanguage(this.state.language);
    return (
      <div>
        <ProgressBar className="fixed loading" style={{ display: "none" }} />

        <Notifications />

        <div className="navbar-fixed">
          <nav className="shadowed">
            <div className="nav-wrapper">
              <Link to="/" className="brand-logo hide-on-med-and-down">
                <img
                  src={
                    BASE_URL +
                    "/img/white-label/logo/SMILE_Logo-ikon-singkatan_1.png"
                  }
                />
              </Link>
              <a
                href="#"
                data-activates="mobile-demo"
                className="button-collapse"
              >
                <i className="material-icons">menu</i>
              </a>
              <form
                onSubmit={this.handleSearchCourse.bind(this, "#search_mobile")}
                className="hide-on-large-only"
              >
                <div className="input-field">
                  <Link to="/" className="brand-logo">
                    <img
                      src={
                        BASE_URL +
                        "/img/white-label/logo/SMILE_Logo-ikon-singkatan_1.png"
                      }
                    />
                  </Link>
                  <Link
                    id="search_url"
                    to="{this.state.search_url}"
                    className="hide"
                  />
                  <input
                    placeholder={trans.search_course_event}
                    id="search_mobile"
                    type="search"
                  />
                  <label className="label-icon" htmlFor="search">
                    <i className="material-icons">search</i>
                  </label>
                </div>
              </form>

              {/* {CheckAuth() && (
								<ul
									className="right hide-on-med-and-down"
									style={{ marginRight: "180px" }}
								>
									<li>
										<Link className="font-orange" to="/course/catalog">
											{trans.course}
										</Link>
									</li>
									<li>
										<Link className="font-orange" to="/event/catalog">
											{trans.event}
										</Link>
									</li>
								</ul>
							)} */}

              <SideNav
                trigger={
                  CheckAuth() ? (
                    <a
                      className="right btn-menu font-orange ellipsis"
                      style={{ maxWidth: "180px" }}
                    >
                      {counter > 0 && (
                        <div
                          className="badge hide red center absolute-right"
                          style={{ top: 0 }}
                        >
                          {counter}
                        </div>
                      )}
                      <span>
                        <img className="circle" src={CheckAuth().foto} />
                        <span className="hide-on-med-and-down">
                          {" "}
                          &nbsp; &nbsp; {CheckAuth().nama}{" "}
                        </span>
                      </span>
                    </a>
                  ) : (
                    <a className="right btn-menu font-orange hide-on-large-only">
                      <i className="material-icons">menu</i>
                    </a>
                  )
                }
                options={{
                  closeOnClick: true,
                  edge: "right",
                  draggable: false,
                }}
              >
                {CheckAuth() && (
                  <span>
                    <SideNavItem
                      userView
                      user={{
                        image: CheckAuth().foto,
                        name: CheckAuth().nama,
                      }}
                    />
                    <SideNavItem divider />
                    <li>
                      <Link to="/course/catalog">{trans.home}</Link>
                    </li>
                    <li>
                      <Link to="/course/catalog?category_id=2">{trans.smile_training}</Link>
                    </li>
                    <li>
                      <Link to="/profile">{trans.profile}</Link>
                    </li>
                    <SideNavItem divider />
                    <li>
                      <Link className="hide-on-large-only" to="/faq">
                        {trans.faq}
                      </Link>
                    </li>
                    <li>
                      <Link className="hide-on-large-only" to="/contacts">
                        {trans.contact_us}
                      </Link>
                    </li>
                    {/* <li>
                      <Link className="hide-on-large-only" to="/publication">
                        {trans.publication}
                      </Link>
                    </li> */}
                    <SideNavItem divider />
                    <li>
                      <Link to="/logout">{trans.logout}</Link>
                    </li>
                  </span>
                )}

                {!CheckAuth() && (
                  <span>
                    <li>
                      <Link className="hide-on-large-only" to="/faq">
                        {trans.faq}
                      </Link>
                    </li>
                    <li>
                      <Link className="hide-on-large-only" to="/contacts">
                        {trans.contact_us}
                      </Link>
                    </li>
                    {/* <li>
                      <Link className="hide-on-large-only" to="/publication">
                        {trans.publication}
                      </Link>
                    </li> */}
                    <li>
                      <Link to="/login">{trans.login}</Link>
                    </li>
                    <li>
                      <Link to="/register">{trans.register}</Link>
                    </li>
                  </span>
                )}
              </SideNav>
              <div style={{ marginLeft: "130px" }}>
                <Modal
                  bottomSheet
                  trigger={
                    <a className="left center-align mr-s font-grey font-tiny prl-m btn-catalog hide-on-med-and-down">
                      <Icon className="ic-catalog" medium>
                        apps
                      </Icon>
                      <span className="hide-on-med-and-down">
                        {trans.catalog}
                      </span>
                    </a>
                  }
                >
                  <Row className="container">
                    <Col s={12}>
                      <a className="modal-close right">
                        <Icon>clear</Icon>
                      </a>
                      <h4 className="mb-m">{trans.course_catalog}</h4>
                      <hr />
                    </Col>

                    {this.state.loadingCategory && (
                      <Col className="pt-m loading">
                        <Preloader size="big" />
                      </Col>
                    )}
                    {!this.state.loadingCategory &&
                      this.state.categories.map((category, i) => (
                        <Col
                          key={"topcat-" + category.id}
                          s={12}
                          m={category.subcategories.length > 6 ? 9 : 6}
                          className="height-100 pr-s"
                        >
                          <div className="valign-wrapper mb-xs">
                            <img
                              className="tiny mr-s"
                              src={category.icon_url}
                            />
                            <div className="h5">{category.name}</div>
                          </div>
                          <div style={{ marginLeft: "45px" }}>
                            {Array.isArray(category.subcategories) &&
                              category.subcategories.map((subcategory, j) => (
                                <span
                                  className="inline"
                                  key={"cat-" + subcategory.id}
                                >
                                  <Link
                                    className="modal-close"
                                    to={`/course/catalog?category_id=${subcategory.id}`}
                                  >
                                    {subcategory.name} (
                                    {/* {subcategory.available_courses.length}) */}
                                  </Link>{" "}
                                  &nbsp; &nbsp;{" "}
                                </span>
                              ))}
                          </div>
                        </Col>
                      ))}
                  </Row>
                </Modal>

                <form
                  style={{ width: "188px", marginRight: "10px" }}
                  onSubmit={this.handleSearchCourse.bind(this, "#search")}
                  className="hide-on-med-and-down left form-bordered"
                >
                  <div className="input-field">
                    <input
                      className="search"
                      placeholder={trans.search_course_event}
                      id="search"
                      type="text"
                      style={{ fontSize: "14px" }}
                    />
                  </div>
                </form>
                {/* <ul className="hide-on-med-and-down">
									<li>
										<Link to="/course/catalog">Course</Link>
									</li>
									<li>
										<Link to="/event/catalog">Event</Link>
									</li>
								</ul> */}

                <ul id="nav-mobile" className="hide-on-med-and-down">
                  {CheckAuth() && (
                    <li>
                      <Link to="/course/catalog">
                        <span className="font-blue">{trans.home}</span>
                      </Link>
                    </li>
                  )}
                  {CheckAuth() && (
                    <li>
                      <Link to="/course/catalog?category_id=2">
                        <span className="font-blue">{trans.smile_training}</span>
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link to="/faq">
                      <span className="font-blue">{trans.faq}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/contacts">
                      <span className="font-blue">{trans.contact_us}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/guide">
                      <span className="font-blue">{trans.guide}</span>
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/publication">
                      <span className="font-blue">{trans.publication}</span>
                    </Link>
                  </li> */}
                </ul>
              </div>

              {!CheckAuth() && (
                <ul id="nav-mobile" className="right hide-on-med-and-down">
                  <li>
                    <Link to="/login">{trans.login}</Link>
                  </li>
                  <li>
                    <Link to="/register">{trans.register}</Link>
                  </li>
                </ul>
              )}
            </div>
          </nav>
        </div>

        <Main counter={counter} />

        <footer className="page-footer example">
          <div className="bg-white pad-m">
            <div className="container">
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "32px",
                }}
              >
                <img src={KemenkesLogo} style={{ height: "48px" }} />
                <img src={UndpLogo} style={{ height: "116px" }} />
              </div>
              <Row style={{ marginTop: "64px" }}>
                <Col className="center" s={12} m={12} l={12}>
                  <button
                    onClick={() =>
                      this.setState((state) => {
                        return { language: "id" };
                      })
                    }
                  >
                    Indonesia
                  </button>
                  <button
                    onClick={() =>
                      this.setState((state) => {
                        return { language: "en" };
                      })
                    }
                  >
                    English
                  </button>
                  <h5 className="copyright pad-m">
                    Copyright 2024 © Smile Elearning
                  </h5>
                </Col>
              </Row>
              {/* <Col m={1}/> */}
              {/* <Col className="center" s={12} m={4} style={{"text-align": "left"}}>
									<div>
										<button onClick={() => this.setState((state) => {
											return {language:"id"}
										})}>Indonesia</button>
										<button onClick={() => this.setState((state) => {
											return {language:"en"}
										})}>English</button>
									</div>
								</Col> */}
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App.js